import { ChangeDetectionStrategy, Component, isStandalone } from '@angular/core';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { ReadMoreComponent } from '../../../display/read-more/read-more.component';
import { IfStandaloneDirective } from '@df/module-pwa/utils/if-standalone.directive';
interface ITextHeaderVariant {
    title: string;
    components: NICmsContentComponent.IData[];
    description: string;
}
@ICmsComponent<PageComponentTextHeaderVariant>({
    id: 'text-header-variant',
    name: 'Text header variant',
    tags: ['plp', 'header'],
    onDemandOnly: true,
    fields: [
        {
            key: 'title',
            type: NICmsContentField.EFieldType.text,
            title: 'Title',
            required: true,
            default: 'Lorem ipsum'
        },
        {
            key: 'description',
            type: NICmsContentField.EFieldType.text,
            title: 'Description',
            required: true,
            default:
                'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum'
        },
        <NICmsContentField.IField>{
            type: NICmsContentField.EFieldType.components,
            key: 'components',
            title: 'Components',
            itemName: 'component',
            default: []
        }
    ]
})
@Component({
    selector: 'text-header-variant',
    templateUrl: './text-header-variant.html',
    styleUrls: ['./text-header-variant.scss'],
    standalone: true,
    imports: [ICmsClientModule, ReadMoreComponent, IfStandaloneDirective],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageComponentTextHeaderVariant extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component!: ITextHeaderVariant;
}
